export default "__VITE_ASSET__CUC3H6vO__"